module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('q-layout', {
    ref: "layout",
    staticClass: "layout",
    attrs: {
      "reveal": "reveal",
      "left-breakpoint": 4000
    }
  }, [(_vm.header && !_vm.home) ? _c('div', {
    staticClass: "header",
    slot: "header"
  }, [_c('div', {
    staticClass: "toolbar cf",
    staticStyle: {
      "background": "none !important"
    }
  }, [_c('q-btn', {
    staticClass: "menubtndroite fr",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.$refs.layout.toggleLeft()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars fa-2x white"
  })]), _c('div', {
    staticClass: "breadcrumb"
  }, [_c('breadcrumb', {
    staticClass: "f6"
  })], 1)], 1)]) : _vm._e(), _c('q-scroll-area', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    slot: "left"
  }, [_c('i', {
    staticClass: "fa fa-close fa-2x white fr right-0 top-0 pa3 absolute pointer",
    on: {
      "click": function($event) {
        _vm.$refs.layout.toggleLeft()
      }
    }
  }), _c('q-list-header', {
    staticClass: "blocmenu w-100 flex justify-between items-center"
  }, [_c('div', {
    staticClass: "enhaut inset-shadow"
  }, [_c('img', {
    staticClass: "pt2 pointer",
    attrs: {
      "src": require("@/assets/newlogos/logo_DOAJC_cropped.png"),
      "width": "250px"
    },
    on: {
      "click": function($event) {
        _vm.goTo()
      }
    }
  })]), _c('div', {
    staticClass: "aumilieu"
  }, [_c('div', {
    staticClass: "link pt3"
  }, [_c('q-side-link', {
    attrs: {
      "to": "/songs"
    }
  }, [_c('h1', [_vm._v("The songs")])])], 1), _c('div', {
    staticClass: "link"
  }, [_c('q-side-link', {
    attrs: {
      "to": "/story"
    }
  }, [_c('h1', [_vm._v("The story")])])], 1), _c('div', {
    staticClass: "link"
  }, [_c('q-side-link', {
    attrs: {
      "to": "/film"
    }
  }, [_c('h1', [_vm._v("The film")])])], 1)]), _c('div', {
    staticClass: "enbas"
  }, [_c('hr', {
    staticClass: "white w-50 mb3"
  }), _c('h2', [_vm._v("Watch the documentary on CBC, december 7th 9PM ET")]), _c('hr', {
    staticClass: "white w-50 mt3 mb3"
  }), _c('div', {
    staticClass: "socialicons inline"
  }, [_c('a', {
    staticClass: "social-icon",
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/pg/jewishxmasfilm"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-2x white ph2"
  })]), _c('a', {
    staticClass: "social-icon",
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/jewishxmasfilm/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x white ph2"
  })]), _c('a', {
    staticClass: "social-icon",
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/jewishxmasfilm"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-2x white ph2"
  })])]), _c('h3', [_vm._v("RIDDLE FILMS INC. © 2017")])])])], 1), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80b4a9ae","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/layout/BaseLayout.vue
// module id = 1287
// module chunks = 1